import { Skeleton } from "@pushpress/pushpress-ui";

export default function StripeLoadingScreen() {
  return (
    <div className="tw-h-auto tw-w-auto tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-w-full tw-max-w-lg tw-space-y-6">
        <div className="tw-flex tw-gap-4">
          <div className="tw-flex-1">
            <Skeleton className="tw-h-[100px] tw-w-full tw-rounded-lg" />
          </div>
          <div className="tw-flex-1">
            <Skeleton className="tw-h-[100px] tw-w-full tw-rounded-lg" />
          </div>
        </div>
        <div className="tw-space-y-4">
          <div>
            <Skeleton className="tw-h-4 tw-w-24 tw-mb-2" />
            <Skeleton className="tw-h-10 tw-w-full tw-rounded" />
          </div>
          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
            <div>
              <Skeleton className="tw-h-4 tw-w-24 tw-mb-2" />
              <Skeleton className="tw-h-10 tw-w-full tw-rounded" />
            </div>
            <div>
              <Skeleton className="tw-h-4 tw-w-24 tw-mb-2" />
              <Skeleton className="tw-h-10 tw-w-full tw-rounded" />
            </div>
          </div>
          <div>
            <Skeleton className="tw-h-4 tw-w-24 tw-mb-2" />
            <Skeleton className="tw-h-10 tw-w-full tw-rounded" />
          </div>
          <div>
            <Skeleton className="tw-h-4 tw-w-24 tw-mb-2" />
            <Skeleton className="tw-h-10 tw-w-full tw-rounded" />
          </div>
          <Skeleton className="tw-h-10 tw-w-full tw-rounded" />
        </div>
      </div>
    </div>
  );
}
